import React from 'react';
import { Card, CardBody } from 'reactstrap';
import Comment from './Comment';

export default function CommentList({ comments = [], onReply }) {
  return (
    <Card>
      <CardBody>
        <h5 className="mb-3">Comments</h5>
        <section aria-label="Comments">
          {comments.length === 0 ? (
            <p className="text-muted mb-0">No comments yet.</p>
          ) : (
            comments.map((c) => (
              <Comment key={c.commentId || c.createdAt} comment={c} onReply={onReply} />
            ))
          )}
        </section>
      </CardBody>
    </Card>
  );
}
